module.exports = __webpack_public_path__ + "static/media/booking.9a8ae7cb.png";